import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BellRing } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { clientUrl } from '../client360/c360Shared';
import { PendBadge, isManager } from '../pendencias/pendShared';
import { AlertComercialDialog } from '../pendencias/AlertComercialDialog';
import { ComercialLink } from '../comercial360/com360Shared';

const OPEN = ['enviado', 'lido', 'em_atraso', 'pendente_resolucao'];

export const HoraDeMudarList = ({ rows, onChanged }) => {
  const { user } = useAuth();
  const [dlg, setDlg] = useState(null);
  const manager = isManager(user);
  return (
    <div className="rounded-2xl border border-rose-200 bg-rose-50/50 p-4 space-y-3" data-testid="emp360-hora">
      <div>
        <h2 className="text-base md:text-lg font-bold font-[Outfit] text-rose-900">Fidelizações a terminar ({rows.length})</h2>
        <p className="text-xs text-rose-800/80">Clientes desta empresa em "hora de mudar". Energia: no fim da fidelização · Telecom: 60 dias antes.</p>
      </div>
      {rows.length === 0 ? <div className="text-sm text-slate-500">Nenhum cliente em hora de mudar.</div> : (
        <div className="divide-y divide-rose-100 rounded-xl bg-white border border-rose-100 max-h-96 overflow-y-auto">
          {rows.map((r) => {
            const open = r.pendencia && OPEN.includes(r.pendencia.status);
            return (
              <div key={r.contract_id} className="flex flex-wrap items-center gap-3 p-3 text-sm" data-testid={`emp360-hora-${r.contract_id}`}>
                <Link to={clientUrl(r.nif, r.nome, { contractId: r.contract_id })} className="font-semibold hover:underline flex-1 min-w-[140px] truncate">{r.nome}</Link>
                <span className="text-xs text-slate-600">{r.msg}</span>
                <span className="text-xs text-slate-500 w-32 truncate"><ComercialLink id={r.owner_id} name={r.comercial || 'Sem comercial'} /></span>
                {r.pendencia && <PendBadge status={r.pendencia.status} />}
                {manager && !open && r.owner_id && r.owner_id !== user?.id && (
                  <button onClick={() => setDlg(r)} data-testid={`emp360-hora-alert-${r.contract_id}`}
                    className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-rose-600 text-white hover:bg-rose-700 transition-colors">
                    <BellRing className="w-3.5 h-3.5" />Alertar
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}
      <AlertComercialDialog open={!!dlg} items={dlg ? [dlg] : []} onClose={() => setDlg(null)} onSent={onChanged} />
    </div>
  );
};
